import { Container, GridItem, Stack } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { AnimatedNumber, FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyMobility } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyMobility
}

export function DynamicEnergyMobility({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 21, xl: 11 }}
            gridColumnStart={{ base: 1, xl: 1 }}
            gridRowEnd={{ base: 22, xl: 13 }}
            gridColumnEnd={{ base: 3, xl: 4 }}
            alignSelf="flex-end"
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Container marginTop={{ xl: "lg" }}>
                    <Stack
                        flexDirection="column"
                        gap="xs"
                    >
                        <Text>{blok.line1}</Text>
                        <Text>{blok.line2}</Text>

                        <Stack
                            flexDirection="column"
                            gap="none"
                        >
                            <Text showcased>{blok.line3}</Text>

                            <Stack gap="none">
                                <AnimatedNumber
                                    target={blok.thousands}
                                    final={`${blok.thousands} 000`}
                                    suffix="&nbsp;000"
                                />
                            </Stack>
                            <Text showcased>{blok.line4}</Text>
                            <Text showcased>{blok.line5}</Text>
                        </Stack>
                    </Stack>
                </Container>
            </FadeIn>
        </GridItem>
    )
}

export default DynamicEnergyMobility
